import { Brick, registerBrick, BrickContext } from 'olympe';

export default class LockDeviceAwake extends Brick {

    static get LOCK_KEY() {
        return 'AWAKE_LOCK';
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    async update($, inputs, [forwardEvent]) {
        if ('wakeLock' in navigator) {
            try {
                const lock = await navigator.wakeLock.request('screen');
                LockDeviceAwake.getRootContext($).set(LockDeviceAwake.LOCK_KEY, lock);
                forwardEvent();
            } catch (error) {
                console.warn(`${error.name}, ${error.message}`);
                forwardEvent();
            }
        } else {
            console.warn('WakeLock not supported');
            forwardEvent();
        }
    }

    /**
     * @param {!BrickContext} $
     * @return {!BrickContext}
     */
    static getRootContext($) {
        let root = $;
        let parent = root.getParent();
        while (parent) {
            root = parent;
            parent = root.getParent();
        }
        return root;
    }
}

registerBrick('018b7035b3a7969e761e', LockDeviceAwake);
